<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-5.primary
          v-row(no-gutters)
            v-col
              p.mb-0.title.white--text(v-if="appointment") {{ $t('edit_appointment') }}
              p.mb-0.title.white--text(v-else) {{ $t('add_appointment') }}
            v-col.shrink
              v-btn.mr-n2(text icon @click="showModal = !showModal" height)
                v-icon(color="white" :size="24") mdi-close

        v-card-text.pa-0
          v-form(ref="form")
            v-card.pa-4(style="overflow-x: hidden;")
              .appointment-name
                v-text-field.mt-2(v-model="name" label="Title" placeholder="Write appointment title here" outlined dense persistent-hint :rules="rules.not_empty" counter :maxlength="50")
              .price
                v-text-field(v-model="price" label="Price" placeholder="0" outlined dense type="number" :prefix="$currency.symbol" :rules="rules.number_not_empty")
              .description
                v-textarea.mt-0(v-model="description" label="Description" placeholder="Write appointment description here" outlined dense persistent-hint  counter :maxlength="500")
              p.title.mb-0 {{ $t('set_appointment_booking') }}
              v-row.mb-n2(align="center")
                v-col
                  v-text-field(v-model="booking_open" label="Open for booking" placeholder="60" outlined dense type="number" :suffix="booking_open <= 1 ? 'days before' : 'days before'" :rules="rules.number_not_empty" hide-details)
                v-col.px-0(cols="1" align="center")
            
                v-col
                  v-text-field(v-model="booking_close" label="Close Booking" placeholder="1" outlined dense type="number" :suffix="booking_close <= 1 ? 'days before' : 'days before'" :rules="rules.has_day" hide-details)
                //- v-col(cols="3")
                  p.mb-0.body-1 before
              v-row
                v-col
                  span.title.mb-2.mt-4 {{ $t('session') }} 
                  p.substitle.mt-1 {{ $t('set_how_many_sessions') }} 
                  p.mb-2.substitle {{ $t('monday') }}
                  p.ma-0.subtitle {{ $t('example_session_slot_2') }}
                  p.ma-0.subtitle {{ $t('example_session_slot_1') }}
              template(v-for="(sesall, index) in sessionAll")
                v-layout
                  p.body-1.grey--text.text--darken-1 {{ dayFullText(sesall.day) }}
                  v-spacer
                  v-btn.text-capitalize(color="primary" outlined small @click="addSession(index, sesall.day)")
                    v-icon.ml-n1(small) mdi-plus
                    | {{ $t('add_session') }}
                //- template(v-for="session in sesall.sessions")
                template(v-for="(session, idx) in sesall.sessions")
                  v-row(align="center")
                    v-col.py-0(cols="6" align="center")
                      p.mb-0.d-inline {{ session.start_time ? hourFormat(session.start_time) : 'start time' }}
                      v-icon.mx-1.d-inline(small) mdi-minus
                      p.mb-0.d-inline {{ session.end_time ? hourFormat(session.end_time) : 'end time' }}
                    v-col.py-0(cols="3" align="center")
                      p.mb-0 slot : {{ session.slots }}
                    v-col.py-0(cols="3")
                      v-btn(small icon)
                        v-icon(color="teal" size="18" @click="openEditSession(index, idx)") mdi-pencil
                      v-btn.ml-1(small icon)
                        v-icon(color="grey" size="22" @click="deleteSession(index, idx)") mdi-delete-outline
                    //- v-text-field.ml-1(label="Slot Quantity" dense outlined hide-details)
                v-divider.my-3(v-if="sessionAll.length !== index+1")
              p.body-1.mt-4 {{ $t('exclude_date') }}
              div(@click="dateDialog = true")
                v-combobox(v-model="holiday" multiple label="No-appointment Date" append-outer-icon="mdi-calendar" readonly outlined dense hide-details)
                  template(v-slot:selection="{ item }")
                    v-chip.white--text.teal(small close @click:close="removeDate(item)")
                      span {{ item }}
                        //- v-icon(small @click="") mdi-close
              y-dialog(v-model="dateDialog" width='290px' persistent)
                v-date-picker.elevation-2(v-model="seldate" multiple :events="holiday_list" event-color="orange" header-color="primary" color="teal")
                  v-spacer
                  v-btn(text color="accent" @click="seldate = [...holiday]; dateDialog = false") {{ $t('cancel') }}
                  v-btn(text color="teal" @click="holiday = [...seldate]; dateDialog = false") OK
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='grey', text @click='showModal = false')
            | {{ $t('cancel') }}
          v-btn.mr-2(color='accent' depressed height=32 @click="clickSave" :loading="isLoading")
            div {{ $t('save') }}

    .modals
      edit-session(v-if="showEditSessionDialog" :open.sync="showEditSessionDialog" :session.sync="editSes" @updateSession="updateSession($event)")

</template>

<script>
import { mapActions } from 'vuex'
import EditSession from '@/components/dialogs/EditSession.vue'

export default {
  name: 'AddAppointment',
  props: ['open', 'company', 'appointment'],
  components: { EditSession },
  data: () => ({
    dateDialog: false,
    booking_open: null,
    booking_close: null,
    holiday: [],
    seldate: [],
    sessionAll: [
      {
        day: 'mon',
        sessions: []
      },
      {
        day: 'tue',
        sessions: []
      },
      {
        day: 'wed',
        sessions: []
      },
      {
        day: 'thu',
        sessions: []
      },
      {
        day: 'fri',
        sessions: []
      },
      {
        day: 'sat',
        sessions: []
      },
      {
        day: 'sun',
        sessions: []
      }
    ],
    name: null,
    price: null,
    description: null,
    showEditSessionDialog: false,
    editSes: {},
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      number_not_empty: [v => v !== null || 'This field is required'],
      is_selected: [(v) => v !== null || 'This field is required'],
      has_day: [(v) => !!v || 'This field is required', (v) => v > 0 || 'This field is required'],
    },
    holiday_list: []
  }),
  computed: {
    authMember () {
      return this.$store.state.user.member
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  watch: {
  },
  mounted () {
    this.$axios.get('/appointment/holidays')
      .then(resp => {
        this.holiday_list = resp.data.map(m => m.date)
      })
      .catch(() => {})
    if (this.appointment) {
      this.name = this.appointment.name,
      this.price = this.appointment.price/this.$currency.multiplier,
      this.description = this.appointment.description,
      this.booking_open = this.appointment.booking_open,
      this.booking_close = this.appointment.booking_close,
      this.holiday = this.appointment.holiday,
      this.sessionAll.forEach(o => {
        let sess = this.appointment.sessions.filter(f => f.day === o.day)
        if (sess.length > 0) {
          sess.forEach(e => {
            o.sessions.push({ ...e, fill: true })
          })
        }
      })
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getSearchText (item) {
      return item.user.first_name + ' ' + item.user.last_name + ' ' + item.user.email
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let sessions = []
      this.sessionAll.forEach(o => {
        o.sessions.forEach(r => {
          if (r.fill) {
            sessions.push({ day: r.day, start_time: r.start_time, end_time: r.end_time, slots: r.slots })
          }
        })
      })
      if (this.appointment) {
        let data = {
          name: this.name,
          description: this.description,
          price: this.price*this.$currency.multiplier,
          booking_open: this.booking_open,
          booking_close: this.booking_close,
          company: this.company.id,
          holiday: this.holiday,
          sessions: sessions
        }
        this.$axios.put(`/appointment/appointments/${this.appointment.id}`, data)
          .then(resp => {
            this.showMessage(['success', this.$t('success_message.product_edited')])
            this.$emit('update:appointment', resp.data)
            this.showModal = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        let data = {
          name: this.name,
          description: this.description,
          price: this.price*this.$currency.multiplier,
          booking_open: this.booking_open,
          booking_close: this.booking_close,
          company: this.company.id,
          holiday: this.holiday,
          sessions: sessions
        }
        this.$axios.post('/appointment/appointments', data)
          .then(resp => {
            this.showMessage(['success', this.$t('success_message.product_added')])
            this.$emit('added', resp.data)
            this.showModal = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
        
    },
    dayFullText (day) {
      switch (day) {
        case 'mon':
          return 'Monday'
        case 'tue':
          return 'Tuesday'
        case 'wed':
          return 'Wednesday'
        case 'thu':
          return 'Thursday'
        case 'fri':
          return 'Friday'
        case 'sat':
          return 'Saturday'
        case 'sun':
          return 'Sunday'
      }
    },
    addSession(idx, day) {
      this.sessionAll[idx].sessions.push({ day: day, start_time: null, end_time: null, slots: 1, fill: false })
    },
    removeDate(item) {
      let index = this.holiday.indexOf(item)
      if (index >= 0) { 
        this.holiday.splice(index, 1)
      }
      this.seldate = [...this.holiday]
    },
    deleteSession(index, idx) {
      this.sessionAll[index].sessions.splice(idx, 1)
    },
    openEditSession(index, idx) {
      this.editSes = {
        start_time: this.sessionAll[index].sessions[idx].start_time,
        end_time: this.sessionAll[index].sessions[idx].end_time,
        slots: this.sessionAll[index].sessions[idx].slots,
        pIndex: index,
        cIndex: idx
      }
      this.showEditSessionDialog = true
    },
    hourFormat (val) {
      let hour = 0
      let min = 0
      let period = ''
      if (Number(val.substr(0,2)) > 12) {
        hour = Number(val.substr(0,2)) - 12
        min = Number(val.substr(3,2)) > 10 ? Number(val.substr(3,2)) : '0' + Number(val.substr(3,2))
        period = 'PM'
      } else {
        hour = Number(val.substr(0,2)) > 0 ? Number(val.substr(0,2)) : 12
        min = Number(val.substr(3,2)) > 10 ? Number(val.substr(3,2)) : '0' + Number(val.substr(3,2))
        period = 'AM'
      }
      return `${hour}:${min} ${period}`
    },
    updateSession (session) {
      this.$set(this.sessionAll[session.pIndex].sessions[session.cIndex], 'start_time', session.start_time)
      this.$set(this.sessionAll[session.pIndex].sessions[session.cIndex], 'end_time', session.end_time)
      this.$set(this.sessionAll[session.pIndex].sessions[session.cIndex], 'slots', session.slots)
      this.$set(this.sessionAll[session.pIndex].sessions[session.cIndex], 'fill', true)
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "edit_appointment": "Edit Appointment",
    "add_appointment": "Add Appointment",
    "set_appointment_booking": "Set Appointment Booking Range",
    "session": "Session",
    "set_how_many_sessions": "Set how many sessions per day, and how many slots per session. Example:",
    "add_session": "Add session",
    "exclude_date": "Exclude Date",
    "monday": "Monday",
    "example_session_slot_2": "8:00 am - 9:00 am 2 slots",
    "example_session_slot_1": "9:00 am - 10:00 am 1 slot"
  },
  "id": {
    "edit_appointment": "Sunting Janji Temu",
    "add_appointment": "Tambahkan Janji Temu",
    "set_appointment_booking": "Tetapkan Rentang Pemesanan Janji Temu",
    "session": "Sidang",
    "set_how_many_sessions": "Atur berapa banyak sesi per hari, dan berapa banyak slot per sesi. Contoh:",
    "add_session": "Tambahkan sesi",
    "exclude_date": "Kecualikan Tanggal",
    "monday": "Senin",
    "example_session_slot_2": "8:00 am - 9:00 am 2 slot",
    "example_session_slot_1": "9:00 am - 10:00 am 1 slot"
  }
}
</i18n>
